import axios, { AxiosResponse } from 'axios';
import { TopConfig } from '../context/ConfigContext';
import { ScalepointEmailTokenResult } from '../types/services';
import { ScalepointData } from '../components/custom/Scalepoint/Scalepoint';
import * as logger from '../utils/logger';

export const getTokensFromEmail = async (topConfig: TopConfig, email: string) => {
    const { url, headers, method } = topConfig.services.scalepoint.ssoEmail;

    if (!url) {
        logger.logError('Scalepoint getTokensFromEmail service: Url not defined');
        throw new Error('Scalepoint getTokensFromEmail service: Url not defined');
    }
    try {
        const response: AxiosResponse<ScalepointEmailTokenResult> = await axios(url, {
            method,
            headers,
            data: { email: email }
        });

        logger.logDebug('Scalepoint getTokensFromEmail service: Response: ' + JSON.stringify(response));
        return response.status === 200 ? response.data : null;
    } catch (e) {
        logger.logWarning('Scalepoint getTokensFromEmail service: ' + e);
        return null;
    }
};

export const refreshToken = async (topConfig: TopConfig, spUrl: string) => {
    const { url, headers, method } = topConfig.services.scalepoint.sso;

    if (!url) {
        logger.logError('Scalepoint refreshToken service: Url not defined');
        throw new Error('Scalepoint refreshToken service: Url not defined');
    }
    try {
        const response: AxiosResponse<ScalepointData['ssoToken']> = await axios(url, {
            method,
            headers,
            params: { caseToken: spUrl }
        });

        logger.logDebug('Scalepoint refreshToken service: Response: ' + JSON.stringify(response));
        return response.status === 200 ? response.data : null;
    } catch (e) {
        logger.logWarning('Scalepoint refreshToken service: ' + e);
        return null;
    }
};

export const getBasketItems = async (topConfig: TopConfig, spToken: string) => {
    const { url, headers, method } = topConfig.services.scalepoint.basket;

    if (!url) {
        logger.logError('Scalepoint getBasketItems service: Url not defined');
        throw new Error('Scalepoint getEmailToken service: Url not defined');
    }
    try {
        const response: AxiosResponse<{ lossItems: ScalepointData['scalepointItemsInBasket'] }> = await axios(
            url + `/${spToken}`,
            {
                method,
                headers
            }
        );

        logger.logDebug('Scalepoint getBasketItems service: Response: ' + JSON.stringify(response));
        return response.status === 200 ? response.data : null;
    } catch (e) {
        logger.logWarning('Scalepoint getBasketItems service: ' + e);
        return null;
    }
};
